import { Constants } from '@core/Utils/Constants'
import { Language, Messages } from './Language'

export class MiscButton extends Phaser.GameObjects.Image {
	constructor(scene: Phaser.Scene, private buttonIndex: number, private spriteSheet: string, private normalTexture: string, private disabledTexture: string, private hoverTexture: string, private model: ButtonAction, private isRadio: boolean, langID: Messages) {
		super(scene, 0, 0, spriteSheet, normalTexture)
		this.setOrigin(0)
		this.setInteractive()
		let t = this.scene.textures.get(spriteSheet).frames[normalTexture]
		this.OrigWidth = t.width
		this.OrigHeight = t.height
		this.on("pointerup", () => { this.OnPointerUp() })
		this.on("pointerdown", (pointer: Phaser.Input.Pointer, x: number, y: number, event: Phaser.Types.Input.EventData) => {
			event.stopPropagation()
			this.SetHover()
		})
		this.on("pointerout", () => { this.OnPointerOut() })
		this.scene.game.events.on(Constants.EVENTS.TOGGLE_RADIOBUTTONS, (e: number) => { this.ToggleButton(e) });

		this.TextElement = new Phaser.GameObjects.Text(this.scene, 0, 0, Language.Get(langID), Constants.BOARD.MISC_BUTTON_FONT);
		this.TextElement.setOrigin(0.5);
	}

	SetTextures(_normalTexture: string, _disabledTexture: string, _hoverTexture: string): void {
		this.normalTexture = _normalTexture;
		this.disabledTexture = _disabledTexture;
		this.hoverTexture = _hoverTexture;
		this.setTexture(this.spriteSheet, this.normalTexture);
	}

	ToggleButton(e: number): void {
		if (e != this.buttonIndex && this.isRadio) this.SetNormal();
	}

	OnPointerUp(): void {
		this.model.Action(this.buttonIndex);

		if (!this.isRadio)
			this.SetNormal();
	}

	OnPointerOut(): void {
		if (!this.isRadio)
			this.SetNormal();
	}

	SetDisabled(): void {
		this.setTexture(this.spriteSheet, this.disabledTexture)
	}

	SetHover(): void {
		this.setTexture(this.spriteSheet, this.hoverTexture)
	}

	SetNormal(): void {
		this.setTexture(this.spriteSheet, this.normalTexture)
	}

	AlignText(x: number = 0.5, y: number = 0.5): void {
		this.TextElement.setPosition(this.x + this.displayWidth * x, this.y + this.displayHeight * y);
		let downscale = 0.85
		if (this.TextElement.width * this.scale > this.displayWidth * downscale) {
			this.TextElement.setScale(downscale * this.displayWidth / this.TextElement.width)
		} else {
			this.TextElement.setScale(this.scale)
		}
	}

	get Index(): number {
		return this.buttonIndex
	}

	set IsRadio(value: boolean) {
		this.isRadio = value;
	}

	OrigWidth = 0
	OrigHeight = 0

	public TextElement: Phaser.GameObjects.Text;
}

export interface ButtonAction {
	Action(index: number): void
}